const appendVersion = (url, version) => (
   version ? `${url}${url.includes('?') ? '&' : '?'}v=${version}` : url
);

// Profile files are overwritten at a fixed key.  Do not use the CloudFront
// asset domain here because it can continue serving the previous object after
// a replacement upload.  Deployments can override this value when needed.
const PROFILE_PICTURE_S3_URL = process.env.REACT_APP_API_S3_PROFILE_URL ||
   'https://s3.us-east-2.amazonaws.com/lms.uploadedfiles';

// Profile photos are replaced at the same S3 key.  Give every new view a unique
// query value so neither the browser nor a CDN can reuse the old object.
export const getProfilePictureUrl = (key, subdomain, version = Date.now()) => {
   if (!key) return '';

   const value = `${key}`.trim();
   if (/^https?:\/\//i.test(value)) return appendVersion(value, version);

   const normalizedKey = value.replace(/^\/+/, '');
   const tenantPrefix = `${subdomain}/`;
   const path = normalizedKey.startsWith(tenantPrefix)
      ? normalizedKey
      : `${tenantPrefix}${normalizedKey}`;
   return appendVersion(`${PROFILE_PICTURE_S3_URL}/${path}`, version);
};
